import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { AppointmentScheduleModel } from '../../business-entities/appointment-schedule.model';
import { AppointmentDetail } from '../../business-entities/appointmentDetail-model';
import { AppointmentScheduleRequestModel } from '../../business-entities/appointmentSchedule-request-model';
import { AppointmentStatusList, WorkOrderStatus } from '../../business-entities/appointmentStatus-model';
import { BrandViewModel } from '../../business-entities/brand-view-model';
import { DealerHolidayViewModel } from '../../business-entities/dealer-holiday-list-view-model';
import { DealerOpeningHoursViewModel } from '../../business-entities/dealer-opening-hours-view-model';
import { DealerRequestModel, DealerViewModel } from '../../business-entities/dealer-view-model';
import { GenericSchedulerListViewModel } from '../../business-entities/generic-scheduler-list-view-model';
import { MechanicBookedAppointmentDetails } from '../../business-entities/mechanic-booked-appointment-details.model';
import { MechanicDaySchedulerViewModel } from '../../business-entities/mechanic-day-schedule.model';
import { AppointmentPlanningService } from '../../business-services/appointment-planning.service';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { MechanicService } from '../../business-services/mechanic.service';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { MultiStackPopupService } from '../../services/multi-stack-popup.service';
import { SchedulerDayViewComponent } from '../../components/af-scheduler-day-view/scheduler-day-view.component';
import { AppointmentService } from '../../business-services/appointment.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Features } from '../../business-entities/user-role-view-model';

const weekEnds = [0, 6];
const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];
@Component({
  selector: 'app-planning',
  templateUrl: './planning.component.html',
  styleUrls: ['./planning.component.css']
})
export class PlanningComponent implements OnInit {

  dealerList: DealerViewModel[];
  dealers: DealerViewModel[] = [];
  dealerId: string = '';
  weekViewDealerId:string;
  id: string = '0';
  currentView='AppointmentView';
  isShowAll:boolean=true;
  selectedDate=new Date();
  schedulerModal:any;
  schedulerHeaderInfo:any;
  appointmentSchedule: AppointmentScheduleModel;
  isSearched:boolean=false;
  genericSchedulerListViewModel: GenericSchedulerListViewModel[];
  dealerWorkingHours: DealerOpeningHoursViewModel[] = [];
  dealerHolidays: DealerHolidayViewModel[] = [];
  isServicesAdded: boolean = false;
  daySchedulerViewModel: MechanicDaySchedulerViewModel;
  hours: Array<number> = [];
  isView:boolean = true;
  dealerName:string='';
  weekViewDealerName:string='';
  errorMessage: string = '';
  isErrorMessage: boolean = false;
  noMechanicAssociated:boolean=false;
  distinctDealers: any[] = [];
  dealerHours = {
    plannedHours: [],
    availableHours: []
  };
  dealerData: any[] = [];
  dealerRequestModel:DealerRequestModel = {
    keyLocation:false,
    onlinePayment:false,
    isAdvanceSearch:false,
    statusId:0,
    isAllDealer:false,
    isForList: false
  };
  currentMonthName:string='';
  currentYear:number;
  showWeekView:boolean=false;
  currentMonth:number;
  weekArray:any[] = [];
  weekDates:any[] = [];
  activeWeekIndex:number;
  weekStartDate:string;
  weekEndDate:string;
  workOrderData:any[] = [];
  contactDetails: AppointmentDetail;
  brandList: BrandViewModel[];
  appointmentStatusList: AppointmentStatusList[] = []
  dealerHolidayDates: Date[] = [];
  workOrderStatusList: WorkOrderStatus[];
  features: Features[] = [];
  isBlockMechanic = false;
  showLegend = false;
  mechanicLeaveTypesList: any[] = [];
  @HostListener('document:keypress', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode === 13) {
        this.onSearch();
        event.preventDefault();
    }
  }
// Add For Hover Details on Week view 
  appointmentSlotDetails = {
    appointmentId: null,
    customerName: '',
    licensePlate: '',
    mechanicName: '',
    mechanicId: '',
    isDisplayMouseHoverDetail: true,
    workOrderNo: null,
    workOrderColor: null,
    brand: null,
    brandCode: null,
    totalHours: '',
    workOrderStatus:'',
    jobLists: [],  
    jobDetailDescription: []
  };
  isDetailVisible: boolean = false;
  slotDetailPosition = { top: 0, left: 0 };
  showTotalHours: boolean = true
  dayViewScrollLeft: { scrollTop: number; scrollLeft: number } = { scrollTop: 0, scrollLeft: 0 };
  @ViewChild('dayViewRef') dayViewRef: SchedulerDayViewComponent;

  constructor(
    public mechanicService: MechanicService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private dealerService: DealerBusinessService,
    private appointmentPlanningService: AppointmentPlanningService,
    private userService: UserDataService,
    private multiStackPopupService: MultiStackPopupService,
    private appointmentService: AppointmentService,
    private currentLanguageService: CurrentLanguage,
    private secureStorage: SecureStorage,
  ) { }

  ngOnInit(): void {
    this.dealerId = this.userService.currentUserValue.defaultDealerId;
    this.GetAll();
      this.currentLanguageService.currentLanguage.subscribe((res) => {
        this.GetAllWorkOrderStatus(res);
  });
  if(this.dealerId != ''){
    this.onSearch();
  }
  this.GetMechanicLeaveTypes();
}

  GetMechanicLeaveTypes() {
    this.mechanicService.GetMechanicLeaveTypes().then((response: any) => {
      if (response?.responseObject) {
        this.mechanicLeaveTypesList = response.responseObject;
        this.mechanicLeaveTypesList = this.mechanicLeaveTypesList.filter(x=>!x.isDeleted);
      }
    });
  }

onDayViewScroll(scroll: { scrollTop: number; scrollLeft: number }): void {
  this.dayViewScrollLeft = scroll;
}

syncMechanicScroll(scrollTop: number): void {
  this.dayViewRef?.scrollTo(scrollTop);
}

getFeatures() {
  this.features = this.secureStorage.getKeyData('feature');
  if (this.features?.length > 0) {
      this.isBlockMechanic = this.features.find(x => x.featureCode === Enums.FeatureCode.BlockMechanic)?.isActive;
  }
}
GetAllWorkOrderStatus(language){
  let model={
    DealerId: this.dealerId,
    LanguageCode:language
  }
  this.appointmentService.GetAllWorkOrderStatus(model).then(data => {
    this.workOrderStatusList = data.responseObject.workOrderStatusList;
  })
}

  GetAll() {
    this.mechanicService.GetDealerList(this.dealerRequestModel).then(data => {
      this.dealerList = data.responseObject;
      for (let value of this.dealerList){
        this.dealers.push(value)
      }
      if(this.dealers?.length===1) 
      {
        this.dealerId = this.dealers[0].dealerId;
        this.weekViewDealerId = this.dealers[0].dealerId;
        this.onSearch();
        this.onWeekViewDealerSearch();
      }
    })
  }
  onSearch(){
    this.genericSchedulerListViewModel = [];
    if(this.dealerId && this.dealerId.length > 0) {
      this.getAllDetails();
      this.isSearched = true;
    }
    this.isSearched = false;
  }
  onTabChange(event:any){
    this.currentView= event.nextId
    if(this.currentView==='Week View'){
      this.getScheduleSummary();
    }
    if(this.currentView==="MonthWeekView"){
       this.weekViewDealerId = this.userService.currentUserValue.defaultDealerId;
       this.onWeekViewDealerSearch();
    }
  }
  async weekDetail(event?:any){
    const getWeekDataRequestModel:any={
      dealerId:this.dealerId,
      startDate:event?new Date(event.startDate):new Date(this.selectedDate),
      endDate:event?new Date(event.endDate):new Date(this.selectedDate),
    }
    await this.appointmentPlanningService.getWeekData(getWeekDataRequestModel);
  }

  async RefreshDayData() : Promise<void>{
    await this.getDealerWorkingHoursAndHolidayList()
    let dealerNotWorking = this.dealerWorkingHours.filter((x)=>(x.dayNumber == this.selectedDate.getDay()) && !x.open)
    this.dealerHolidays?.forEach(element => {
      for (var d = Utility.getDateStringToDate(element?.startDate); d <= Utility.getDateStringToDate(element?.endDate); d.setDate(d.getDate() + 1)) {
        this.dealerHolidayDates.push(new Date(d));
    }
    });
    let dealerHolidays = this.dealerHolidayDates?.filter((y) => Utility.GetFormattedDate(y) == Utility.GetFormattedDate(this.selectedDate))
     if(dealerNotWorking?.length > 0 || dealerHolidays?.length > 0 ){
       this.appointmentSchedule = null;
      this.daySchedulerViewModel = null;
       this.genericSchedulerListViewModel = null;
       await this.getMechaicMonthwiseHours(this.selectedDate);
       await this.getAppointmentSchedule(new Date(this.selectedDate));
     }
     else{
      await this.getMechaicMonthwiseHours(this.selectedDate);
      await this.getAppointmentSchedule(new Date(this.selectedDate));
    }
  }


  async getWeekDetails(){
    const getWeekDataRequestModel:any={
      dealerId:this.dealerId,
      startDate:new Date(this.selectedDate).getFullYear(),
      endDate:new Date(this.selectedDate).getMonth()+1,
    }
    await this.appointmentPlanningService.getWeekData(getWeekDataRequestModel);
  }
  async onAddBooking(isAdded: boolean): Promise<void> {
    if (isAdded) {
      await this.getAppointmentSchedule();
    }
  }
  async getScheduleSummary(date?: Date) {
    if(date){
      if (!isNaN(date.getTime())){
        this.selectedDate = date;
      }
    }

    const getSchedulesummaryModel: any = {
      UserId: this.userService.currentUserValue.userId,
      //UserId: '4B9CB069-C852-49D2-AE2D-42116420564C',
      year:new Date(this.selectedDate).getFullYear(),
      month:new Date(this.selectedDate).getMonth() + 1,
    }

    await this.appointmentPlanningService.getScheduleSummary(getSchedulesummaryModel)
      .then( result => {
        this.schedulerHeaderInfo = result;
        this.distinctDealers = [...new Set( this.schedulerHeaderInfo.map(obj => obj.dealerName)) ];
        let arrList = [];
        this.distinctDealers.forEach(dealer => {
          const dealerData = this.schedulerHeaderInfo.filter(x => x.dealerName === dealer);
          let map = dealerData.reduce((prev, next) =>{
            if (next.monthOfDate in prev) {
              prev[next.monthOfDate].plannedHours += next.plannedHours;
              prev[next.monthOfDate].availableHours += next.availableHours;
            } else {
               prev[next.monthOfDate] = next;
            }
            return prev;
          }, {});
          let result = Object.keys(map).map(id => map[id]);
          arrList.push({
            dealerName: dealer,
            plannedHours: result.map(x => x.plannedHours),
            availableHours: result.map(x => x.availableHours),
            open: result.map(x => x.open),
            dealerWeekends: this.getDealerHolidays(new Date(this.selectedDate)),
            bookedPercentage: result.map(x => x.bookedPercentage),
          });
        })
        this.dealerData = arrList;
      })
  }
  onWeekViewDealerSearch(){
    if(this.weekViewDealerId == '' || this.weekViewDealerId == undefined || this.weekViewDealerId == null){
      return;
    }
    this.showWeekView = true;
    this.currentMonth = new Date().getMonth();
    this.currentMonthName = monthNames[this.currentMonth];
    this.currentYear = new Date().getFullYear();
    let startWeek = this.datePipe.transform(new Date(this.currentYear,this.currentMonth,1), 'w');
    let endWeek = this.datePipe.transform(new Date(this.currentYear, this.currentMonth + 1, 0),'w');
    this.CreateWeekArray(startWeek,endWeek);
    if (this.weekArray && this.weekArray.length > 0) {
      this.weekArray[0].isActive = true;
    }
    this.activeWeekIndex = 0;
    let wholeWeek = Utility.getFullWeeksStartAndEndInMonth(this.currentMonth,this.currentYear);
    this.weekDates = this.DateFromWeekNumber(wholeWeek[0]);
    this.weekStartDate = this.weekDates[0].dayDate;
    this.weekEndDate = this.weekDates[this.weekDates.length - 1].dayDate;
    this.GetWeekViewPlanning();
  }

  OnWorkOrderClick(appointmentId){
    this.multiStackPopupService.OpenAppointment(appointmentId);
  }

  GetWeekViewPlanning(){
    this.spinner.show();
    const requestModel:any = {
      dealerId: this.weekViewDealerId,
      weekDates: this.weekDates
    }
    this.appointmentPlanningService.GetWeekViewPlanning(requestModel)
    .then((result)=>{
      this.workOrderData = this.MapResult(result);
      this.spinner.hide();
    });
  }
  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
         const key = keyGetter(item);
         const collection = map.get(key);
         if (!collection) {
             map.set(key, [item]);
         } else {
             collection.push(item);
         }
    });
    return map;
}
  MapResult(result){
    let finalArray = [];
    if(result != null){
      result.forEach((element) => {
        element.dateWiseMechanicAllocation.forEach(y => {
          y.dayDate = new Date(Utility.ConvertLocalDateToUTCDate(y.dayDate));
          this.dealerName = y.dealerName;
        });
        const grouped = this.groupBy(element.dateWiseMechanicAllocation, pet => pet.dayDate.getDate());
        let array = [];
         this.weekDates.forEach(x => {
            let item = grouped.get(new Date(x.dayDate).getDate());
            array.push(item);
         });
        let Obj = {
          mechanicName:element.mechanics.mechanicName,
          workOrderData:array
        }
        finalArray.push(Obj);
      })
      return finalArray;
    }
  }
  CreateWeekArray(startWeek,endWeek){
    startWeek = parseInt(startWeek);
    endWeek = parseInt(endWeek);
    this.weekArray = [];
    for(let i = startWeek;i<=endWeek;i++){
      let Obj = {
        weekNumber:i,
        isActive:false
      }
      this.weekArray.push(Obj);
    }
  }
  OnWeekClick(index){
  this.weekArray.forEach((element) => {
    element.isActive = false;
  });
  this.weekArray[index].isActive = true;
  let wholeWeek = Utility.getFullWeeksStartAndEndInMonth(this.currentMonth,this.currentYear);
  this.weekDates = this.DateFromWeekNumber(wholeWeek[index]);
  this.activeWeekIndex = index;
  this.weekStartDate = this.weekDates[0].dayDate;
  this.weekEndDate = this.weekDates[this.weekDates.length - 1].dayDate;
  this.GetWeekViewPlanning();
  }
  onWeekViewDealerChange(value){
    this.showWeekView = false;
    if(value){
      this.weekViewDealerName =  this.dealers.filter(x=>x.dealerId === this.weekViewDealerId)[0]?.name
    } else {
      this.weekViewDealerId = '';
    }
  }
  PreviousMonth(){
    this.currentMonth = this.currentMonth - 1;
    if(this.currentMonth<0){
      this.currentMonth = 11;
      this.currentYear = this.currentYear - 1;
    }
    this.currentMonthName = monthNames[this.currentMonth];
    let startWeek = this.datePipe.transform(new Date(this.currentYear,this.currentMonth,1), 'w');
    let endWeek = this.datePipe.transform(new Date(this.currentYear, this.currentMonth + 1, 0),'w');
    this.CreateWeekArray(startWeek,endWeek);
    if (this.weekArray && this.weekArray.length > 0) {
      this.weekArray[0].isActive = true;
    }
    this.activeWeekIndex = 0;
    let wholeWeek = Utility.getFullWeeksStartAndEndInMonth(this.currentMonth,this.currentYear);
    this.weekDates = this.DateFromWeekNumber(wholeWeek[0]);
    this.weekStartDate = this.weekDates[0].dayDate;
    this.weekEndDate = this.weekDates[this.weekDates.length - 1].dayDate;
    this.GetWeekViewPlanning();
  }
  DateFromWeekNumber(dates:any){
    let weekDates = [];
    dates.forEach(element => {
      let Obj = {
        dayName: element.day,
       dayDate:element.wholeDate.toDateString(),
        weekShortName:Enums.ShortWeekName[element.day],
        day:element.wholeDate.getDate()
  }
  weekDates.push(Obj);
    });
return weekDates;
  }
  NextMonth(){
    this.currentMonth = this.currentMonth + 1;
    if(this.currentMonth>11){
      this.currentMonth = 0;
      this.currentYear = this.currentYear + 1;
    }
    this.currentMonthName = monthNames[this.currentMonth];
    let startWeek = this.datePipe.transform(new Date(this.currentYear,this.currentMonth,1), 'w');
    let endWeek = this.datePipe.transform(new Date(this.currentYear, this.currentMonth + 1, 0),'w');
    let wholeWeek = Utility.getFullWeeksStartAndEndInMonth(this.currentMonth,this.currentYear);
    this.CreateWeekArray(startWeek,endWeek);
    if (this.weekArray && this.weekArray.length > 0) {
      this.weekArray[0].isActive = true;
    }
    this.activeWeekIndex = 0;
    this.weekDates = this.DateFromWeekNumber(wholeWeek[0]);
    this.weekStartDate = this.weekDates[0].dayDate;
    this.weekEndDate = this.weekDates[this.weekDates.length - 1].dayDate;
    this.GetWeekViewPlanning();
  }

  async getAllDetails(): Promise<void> {
    await this.getMechaicMonthwiseHours();
    await this.getAppointmentSchedule();
    await this.getDealerWorkingHoursAndHolidayList();
  }

  async schedulerMonthChange(date?:Date){
    await this.getMechaicMonthwiseHours(date);
    await this.getAppointmentSchedule(date)
  }

  scheduleSummaryMonthChange(date?:Date) {
    this.getScheduleSummary(date);
    this.spinner.hide();
  }

  async reloadBookings(date?: Date) {
    await this.getMechaicMonthwiseHours(date);
    await this.getAppointmentSchedule(date);
  }
  async onShowAllMechanics(showAllMechanic: boolean): Promise<void> {
    // this.isShowAll=showAllMechanic;
    // await this.getMechaicMonthwiseHours(this.selectedDate);
    // await this.getAppointmentSchedule(this.selectedDate);

  }
  async getDealerWorkingHoursAndHolidayList(): Promise<void> {
    this.spinner.show();
    this.dealerId = this.dealerId?.length > 0 ? this.dealerId : '';
    const resp = await this.dealerService.GetDealerWorkingHoursAndHoliday(this.dealerId).finally(()=>this.spinner.hide());
    this.dealerWorkingHours = resp.responseObject.dealerOpeningHoursViewModel;
    this.appointmentPlanningService.dealerWorkingHours = this.dealerWorkingHours;
    this.dealerHolidays = resp.responseObject.dealerHolidayViewModel;
    this.appointmentPlanningService.dealerHolidays = this.dealerHolidays;
  }
  setGenericSchedulerList(): void {
    const list: GenericSchedulerListViewModel[] = [];
    this.appointmentSchedule.mechanicShiftDetails.forEach(mechanic => {
      let object: GenericSchedulerListViewModel = {
        pId: +mechanic.mechanicId,
        pText: mechanic.mechanicName,
        icon: mechanic.brandIcon,
        skillDescription: mechanic.skillDescription,
        isIconShow: true,
        iconLength: 0,
        isActive: mechanic.isActive,
        isOnLeave: mechanic.isOnLeave,
        leaveOption: mechanic.leaveOption,
        efficiency: mechanic.mechanicEfficiency,
        isCapacityPlanning:mechanic.isCapacityPlanning,
        competence:mechanic.competence
      };
      list.push(object);
    });
    this.genericSchedulerListViewModel = list.slice();
    this.genericSchedulerListViewModel = [...new Map(this.genericSchedulerListViewModel.map(item => [item.pId, item])).values()]
  }

  setMechanicDaySchedulerViewModel(): void {
    const mechanicShiftDetailsCopy = JSON.parse(JSON.stringify(this.appointmentSchedule.mechanicShiftDetails));
    const object = {
      date: this.selectedDate,
      dealerTimeSlots: this.getDealerTimeSlots(),
      mechanics: mechanicShiftDetailsCopy,
      dayAppointmentList: this.getDayAppointmentList()
    } as MechanicDaySchedulerViewModel;
    this.daySchedulerViewModel = object;
    let originalValues = new Map();
    for (let i of this.daySchedulerViewModel.mechanics) {
      if (originalValues.has(i.mechanicId)) {
        let temp = originalValues.get(i.mechanicId);
        temp.bookedAppointmentList.push(...i.bookedAppointmentList);
        originalValues.set(i.mechanicId, temp);
      } else {
        originalValues.set(i.mechanicId, i);
      }
    }
    this.daySchedulerViewModel.mechanics = [...originalValues.values()];
    this.daySchedulerViewModel.mechanics.forEach((mechanic)=>{
      let data = this.genericSchedulerListViewModel.filter(x=>x.pId === mechanic.mechanicId)[0]?.icon;
      if(data){
        data?.forEach(element => {
          mechanic.bookedAppointmentList?.forEach((appointment)=>{
            if(appointment.brandCode === element.brandCode)
            {
              appointment.brand = element.brandIcon
            }
          })
        });
      }
    })
  }

  getDealerTimeSlots(): string[] {
    let dealerSlots = [];
    let shiftStartTime = this.appointmentSchedule.dealerShiftDetails.shiftStart?this.datePipe.transform(this.appointmentSchedule.dealerShiftDetails.shiftStart, 'HH:mm'):"00:00";
    let shiftEndTime = this.appointmentSchedule.dealerShiftDetails.shiftEnd?this.datePipe.transform(this.appointmentSchedule.dealerShiftDetails.shiftEnd, 'HH:mm') :"00:00";
    // const startHours = +shiftStartTime?.split(":")[0]
    // const endHours = +(shiftEndTime?.split(":")[0])
    const startHours = +EnvSetting.PlanningFromTime;
    const endHours = +EnvSetting.PlanningToTime
    for (let i = startHours; i <= endHours; i++) {
      dealerSlots.push(`${i}:00`);
    }
    return dealerSlots;
  }

  getDayAppointmentList(): MechanicBookedAppointmentDetails[] {
    const totalAppointments = [];
    this.appointmentSchedule.mechanicShiftDetails.forEach(mechanic => {
      mechanic.bookedAppointmentList?.forEach(appointment => {
        appointment.bookingId = mechanic.bookingId;
        totalAppointments.push(appointment);
      })
    });
    return totalAppointments;
  }
  async getMechaicMonthwiseHours(date?: Date){
    this.spinner.show();
    if(date){
      if (!isNaN(date.getTime())){
        this.selectedDate = date;
      }
    }
    const getMechanicMonthwiseRequestParameter:any={
      dealerId:this.dealerId,
      year:new Date(this.selectedDate).getFullYear(),
      month:new Date(this.selectedDate).getMonth()+1,
      appointmentId:0,
      showAllMechanic:this.isShowAll
    }
    await this.appointmentPlanningService.getMechanicMonthwiseHours(getMechanicMonthwiseRequestParameter)
    .then((result)=>{
      this.schedulerHeaderInfo = result.responseObject;
      let single = Object();
      single.headerInfo = this.schedulerHeaderInfo
      this.schedulerModal = single
    }).finally(()=>{
      this.spinner.hide();
    });
  }
  onDealerChange(value){
    if(value){
      this.dealerName =  this.dealers.filter(x=>x.dealerId === this.dealerId)[0]?.name
    } else {
      this.dealerId = '';
    }
  }
  async getAppointmentSchedule(date?: Date): Promise<void> {
    if (date) {
      if (!isNaN(date.getTime())){
        this.selectedDate = date;
      }
    }
    this.spinner.show();
    const offset = new Date().getTimezoneOffset();
    const utcDate = new Date(this.selectedDate.getTime() - (offset * 60 * 1000));
    const getAppointmentScheduleRequestParameter:AppointmentScheduleRequestModel={
      dealerId:this.dealerId,
      date:this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd'),
      appointmentId:0,
      showAllMechanic:true,
      isForMenu:true,
      isDmsSlotActive : false
    }
   await this.appointmentPlanningService.getAppointmentScheduleDetails(getAppointmentScheduleRequestParameter)
      .then((result) => {
        const response = result.responseObject;

        if (response.errorCount > 0) {
          const errorResponse = response.result;
          this.isSearched = true;
          this.errorMessage = errorResponse.errorMessage;
          this.appointmentSchedule = null;
          this.daySchedulerViewModel = null;
          this.genericSchedulerListViewModel = null;
          if(this.errorMessage.length > 0 && this.errorMessage !== undefined) {
            this.isErrorMessage = true;
            this.noMechanicAssociated = false;
          }
        } else {
          this.appointmentSchedule = result.responseObject;
          if(this.appointmentSchedule?.mechanicShiftDetails){
            this.isSearched=true;
            this.isErrorMessage = false;
           
          }

          if(result.responseObject.mechanicShiftDetails.length > 0){
            let single = Object();
            single.planningResources = this.schedulerResourceMapper(result.responseObject.mechanicShiftDetails,result.responseObject.planningMenuEventDetails);
            single.planningEvents=this.schedulerEventMapper(result.responseObject.planningMenuEventDetails, result.responseObject.mechanicShiftDetails);
            this.schedulerModal = single
            this.isErrorMessage = false;
            this.noMechanicAssociated=false;
          } 
          if( this.appointmentSchedule.mechanicShiftDetails.length === 0){
            this.noMechanicAssociated=true;
          }
          else{
            this.appointmentSchedule.mechanicShiftDetails.forEach(mechanic => {
              mechanic.bookedAppointmentList.forEach(appointment => {
                appointment.appointmentStartTime = Utility.ConvertUTCDateToLocalDate(appointment.appointmentStartTime);
                appointment.appointmentEndTime = Utility.ConvertUTCDateToLocalDate(appointment.appointmentEndTime);
              });
            });
          }
          this.setGenericSchedulerList();
          this.setMechanicDaySchedulerViewModel();
          this.setHours();
        }
        this.spinner.hide();
      }).finally(()=>{
        this.spinner.hide();
      });
  }
  async onDayChange(data): Promise<void> {
    if (data?.isHoliday) {
      this.selectedDate = new Date(data?.actualDate);
      this.appointmentSchedule = null;
      this.daySchedulerViewModel = null;
      this.genericSchedulerListViewModel = null;
      this.isErrorMessage = true;
    } else {
      await this.getAppointmentSchedule(new Date(data?.actualDate));
    }
  }

  private schedulerResourceMapper(mechanicData:any,EventData:any): any[]{
    let superArray = [];
    if(mechanicData.length > 0){
      mechanicData.forEach(element => {
        let supper = Object();
        supper.brands=element.brandIcon;
        supper.mechanicName= element.mechanicName;
        supper.mechanicId=element.mechanicId;
        supper.competence = element.competence;
        supper.shiftInfo= this.appointmentPlanningService.CommonFilterMechanicShift(element.mechanicId,mechanicData,this.selectedDate);
        supper.totalBookedMechanicHours = this.calculateMechanicBookedHours(element.mechanicId, EventData);
        superArray.push(supper);
      });
    }
    return superArray.sort((a, b) => a.mechanicName.localeCompare(b.mechanicName));
  }
  setHours(): void {
    this.hours = [];
    let shiftStartTime = this.appointmentSchedule.dealerShiftDetails.shiftStart?this.datePipe.transform(this.appointmentSchedule.dealerShiftDetails.shiftStart, 'HH:mm') :"00:00";
    let shiftEndTime = this.appointmentSchedule.dealerShiftDetails.shiftEnd?this.datePipe.transform(this.appointmentSchedule.dealerShiftDetails.shiftEnd, 'HH:mm'):"00:00";
    // const startHours = +shiftStartTime?.split(":")[0];
    // const endHours = +(shiftEndTime?.split(":")[0]);
    const startHours = +EnvSetting.PlanningFromTime;
    const endHours = +EnvSetting.PlanningToTime
    for (let i = startHours; i <= endHours; i++) {
      this.hours.push(i);
    }
  }
  private calculateMechanicBookedHours(mechanicId: any, EventData: any) {
    let bookedMechanicHours = 0;
    if (EventData.length > 0) {
      EventData.forEach(element => {
        if (element.mechanicId === mechanicId &&
          this.datePipe.transform(new Date(element.startDate),'dd.MM.yyyy')===this.datePipe.transform(new Date(this.selectedDate),'dd.MM.yyyy')) {
            bookedMechanicHours += (this.calculateTimeDiff(new Date(element.startTime), new Date(element.endTime)));
        }
      });
    }
    return bookedMechanicHours;
  }



  private  schedulerEventMapper(eventInfo:any, mechanicInfo){
    const offset = new Date().getTimezoneOffset();
    let superArray = [];
    let temp = [];
    // if(eventInfo.length > 0){
    //   superArray = eventInfo.filter(x=> this.datePipe.transform(x.startDate,'yyyy-MM-dd') === this.datePipe.transform(this.todayDate,'yyyy-MM-dd'));
    // }
    //Bind Events from other workorders
    if(eventInfo.length>0){
      eventInfo.forEach(el => {
          let eventInfo = Object();
          eventInfo.bookingId=el.bookingId;
          eventInfo.startTime=new Date(new Date(el.startTime).getTime() - (offset * 60 * 1000));
          eventInfo.endTime=new Date(new Date(el.endTime).getTime() - (offset * 60 * 1000));
          eventInfo.startDate= new Date(el.startDate);
          eventInfo.mechanicId=el.mechanicId;
          eventInfo.mechanicName=el.mechanicName;
          eventInfo.licensePlate= el.licensePlate;
          eventInfo.customerName= el.customerName;
          eventInfo.duration = ((this.calculateTimeDiff(new Date(el.startTime), new Date(el.endTime))) * 60);
          eventInfo.brand= el.brand;
          eventInfo.brandLogo= el.brandLogo;
          eventInfo.dealerName= el.dealerName;
          eventInfo.appointmentStatusId= el.appointmentStatusId;
          eventInfo.workOrderStatus= el.workOrderStatus;
          eventInfo.workOrderStatusColor= el.workOrderStatusColor;
          eventInfo.workOrderNumber= el.workOrderNumber;
          superArray.push(eventInfo);
        });
    }
    if (mechanicInfo.length > 0) {
      mechanicInfo.forEach(element => {
        element.bookedAppointmentList.forEach(el => {
          let eventInfo = Object();
          eventInfo.bookingId = el.appointmentId;
          eventInfo.startTime = new Date(new Date(el.appointmentStartTime).getTime() - (offset * 60 * 1000));
          eventInfo.endTime = new Date(new Date(el.appointmentEndTime).getTime() - (offset * 60 * 1000));
          eventInfo.startDate = new Date(el.appointmentStartTime);
          eventInfo.mechanicId = element.mechanicId;
          eventInfo.mechanicName = element.mechanicName;
          eventInfo.licensePlate = el.licensePlate;
          eventInfo.customerName = el.customerName;
          eventInfo.workOrderNo = el.workOrderNo;
          eventInfo.mechanicEfficiency = element.mechanicEfficiency
          eventInfo.duration = ((this.calculateTimeDiff(new Date(el.appointmentStartTime), new Date(el.appointmentEndTime))) * 60);
          if (superArray.length > 0) {
            temp = superArray.filter(x => this.datePipe.transform(x.startTime, 'yyyy-MM-dd HH:mm') === this.datePipe.transform(eventInfo.startTime, 'yyyy-MM-dd HH:mm') &&
              this.datePipe.transform(x.endTime, 'yyyy-MM-dd HH:mm') === this.datePipe.transform(eventInfo.endTime, 'yyyy-MM-dd HH:mm') && x.mechanicId === eventInfo.mechanicId);
            if (temp.length === 0) {
              superArray.push(eventInfo);
            }
          } else {
            superArray.push(eventInfo);
          }
          temp = [];
        });
      });
    }
    return superArray;
  }

  private calculateTimeDiff(start: any, end: any): any {
    let baseDiff = (end - start);
    return (baseDiff % 86400000) / 3600000;
  }

  private onGetCurrentMonthDates(cDate: Date): any[] {
    const currentD = new Date(cDate);
    const month = currentD.getMonth();
    currentD.setDate(1);
    const alldays = [];
    while (currentD.getMonth() === month) {
      const calyear = currentD.getFullYear();
      const calmonth = (currentD.getMonth() + 1).toString().padStart(2, '0');
      const caldate = currentD.getDate().toString().padStart(2, '0');
      const d = `${calyear}-${calmonth}-${caldate}`;
      alldays.push(d);
      currentD.setDate(currentD.getDate() + 1);
    }

    return alldays;
  }

  getDealerHolidays(cDate: Date) {
    const monthAllDates = this.onGetCurrentMonthDates(cDate);
    const isHolidayObj = [];
    for (const monthDate of monthAllDates) {
        // calculate is week ends
      let holiday = weekEnds.indexOf(new Date(monthDate).getDay()) != -1;
      isHolidayObj.push({
        isHoliday: holiday
      })
    }

    return isHolidayObj;
  }

  arrowPosition = {
    top: 0,
    left :0
  }

  @ViewChild('tooltip') toolTip! : ElementRef<HTMLDivElement>;

  showDetail(detail: any, mechanicName: string, event: MouseEvent) {
    const element = event.target as HTMLElement;
    const rect = element.getBoundingClientRect();
    this.appointmentSlotDetails = {
      appointmentId: detail.appointmentId,
      customerName: detail.customerName,
      licensePlate: detail.licensePlate,
      mechanicName: mechanicName,
      mechanicId: detail.mechanicId,
      isDisplayMouseHoverDetail: true,
      workOrderNo: detail.workOrderNumber,
      workOrderColor: detail.workOrderStatusColor,
      brand: detail.brandCode,
      brandCode: detail.brand,
      totalHours: detail.totalHours,
      workOrderStatus : detail.workOrderStatus,
      jobLists: detail.jobLists, 
      jobDetailDescription: detail.jobDetailDescription
    };
    this.isDetailVisible = true;
    setTimeout(() => {
      const element = this.toolTip.nativeElement;
      const dimensions = element.getBoundingClientRect();
      let toolTipPosition = 0;
      let arrowPosition = 0;
      if (rect.right + dimensions.width + 32 < window.innerWidth){
        toolTipPosition = rect.right + (dimensions.width / 2) + 16;
      }else {
        toolTipPosition = rect.left - (dimensions.width / 2) - 16;
        arrowPosition = dimensions.width
      }

      let toolTipAlign = rect.top - (dimensions.height) / 2;
      let arrowAlign = dimensions.height / 2;

      if (rect.bottom + ((dimensions.height) / 2) >= window.innerHeight){
        toolTipAlign = rect.top - ((dimensions.height) / 2) - (rect.bottom + ((dimensions.height) / 2))%window.innerHeight;
        arrowAlign = dimensions.height / 2 + (rect.bottom + ((dimensions.height) / 2)) % window.innerHeight;
      }
      this.slotDetailPosition = {
        top: toolTipAlign,
        left: toolTipPosition
      };  
      this.arrowPosition = {
        top: arrowAlign,
        left: arrowPosition
      }
    }, 0);
  }

  hideDetail() {
    this.isDetailVisible = false;
  }

}